import InputType from "@/services/Input/InputType.js";
import Catalog from "../StockTrfCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " +
      Catalog.StockTrfNumber.Label,
    Type: InputType.Text,
    MaxLength: 50
  },
  Date: {
    Label: Catalog.Date.Label,
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  },
  SourceWarehouseID: {
    Label: Catalog.SourceWarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  },
  DestinationWarehouseID: {
    Label: Catalog.DestinationWarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  },

  // support
  WarehouseID: {
    Label: "Gudang",
    Type: InputType.ID,
    Input: InputType.Select
  }
}